import { render, staticRenderFns } from "./ViewItems.vue?vue&type=template&id=a109ebbe&scoped=true&"
import script from "./ViewItems.vue?vue&type=script&lang=js&"
export * from "./ViewItems.vue?vue&type=script&lang=js&"
import style0 from "./ViewItems.vue?vue&type=style&index=0&id=a109ebbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a109ebbe",
  null
  
)

export default component.exports